// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

.codeActionWidget {
	font-size: 13px;
	border-radius: 0;
	min-width: 160px;
	max-width: 500px;
	z-index: 40;
	display: block;
	width: 100%;
	border: 1px solid var(--vscode-editorWidget-border) !important;
	border-color: none;
	background-color: var(--vscode-editorWidget-background);
	color: var(--vscode-editorWidget-foreground);
	box-shadow: var(--vscode-widget-shadow) 0 2px 8px;
}

.codeActionWidget .monaco-list {
	user-select: none;
	-webkit-user-select: none;
	border: none !important;
	border-width: 0 !important;
}

.codeActionWidget .monaco-list .monaco-scrollable-element .monaco-list-rows {
	height: 100% !important;
}

.codeActionWidget .monaco-list .monaco-scrollable-element {
	overflow: visible;
}

/** Styles for each row in the list element **/
.codeActionWidget .monaco-list .monaco-list-row {
	padding: 0 10px;
	white-space: nowrap;
	cursor: pointer;
	touch-action: none;
	width: 100%;
}

.codeActionWidget .monaco-list .monaco-list-row.code-action.focused:not(.option-disabled)  {
	background-color: var(--vscode-quickInputList-focusBackground);
	color: var(--vscode-quickInputList-focusForeground);
	outline: 1px solid var(--vscode-menu-selectionBorder, transparent);
	outline-offset: -1px;
}

.codeActionWidget .monaco-list-row.group-header {
	color: var(--vscode-pickerGroup-foreground);
	font-weight: bold;
}

.codeActionWidget .monaco-list .group-header,
.codeActionWidget .monaco-list .option-disabled,
.codeActionWidget .monaco-list .option-disabled:before,
.codeActionWidget .monaco-list .option-disabled .focused,
.codeActionWidget .monaco-list .option-disabled .focused:before {
	cursor: default !important;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	background-color: transparent !important;
	outline: 0 solid !important;
}

.codeActionWidget .monaco-list-row.code-action {
	display: flex;
	gap: 10px;
	align-items: center;
}

.codeActionWidget .monaco-list-row.code-action.option-disabled {
	color: var(--vscode-disabledForeground);
}

.codeActionWidget .monaco-list-row.code-action.option-disabled .codicon {
	opacity: 0.4;
}

.codeActionWidget .monaco-list-row.code-action:not(.option-disabled) .codicon {
	color: inherit;
}

.codeActionWidget .monaco-list-row.code-action .title {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* Action bar */

.codeActionWidget .codeActionWidget-action-bar {
	margin-top: 4px;
	margin-bottom: 4px;
}

.codeActionWidget .codeActionWidget-action-bar::before {
	display: block;
	content: "";
	width: 100%;
	margin-bottom: 4px;
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
}

.codeActionWidget .codeActionWidget-action-bar .actions-container {
	padding: 0 10px;
}

.codeActionWidget-action-bar .action-label {
	color: var(--vscode-textLink-activeForeground);
	pointer-events: all;
}

.codeActionWidget-action-bar .action-item {
	margin-right: 10px;
	pointer-events: none;
}

.codeActionWidget-action-bar .action-label:hover {
	background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/monaco-editor-core/esm/vs/editor/contrib/codeAction/browser/codeActionWidget.css"],"names":[],"mappings":"AAAA;;;+FAG+F;;AAE/F;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,WAAW;CACX,8DAA8D;CAC9D,kBAAkB;CAClB,uDAAuD;CACvD,4CAA4C;CAC5C,iDAAiD;AAClD;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAEA,8CAA8C;AAC9C;CACC,eAAe;CACf,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,8DAA8D;CAC9D,mDAAmD;CACnD,kEAAkE;CAClE,oBAAoB;AACrB;;AAEA;CACC,2CAA2C;CAC3C,iBAAiB;AAClB;;AAEA;;;;;CAKC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;CACzB,wBAAwB;CACxB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;CACjB,wCAAwC;CACxC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA,eAAe;;AAEf;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,8CAA8C;CAC9C,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,wCAAwC;AACzC","sourcesContent":["/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.codeActionWidget {\n\tfont-size: 13px;\n\tborder-radius: 0;\n\tmin-width: 160px;\n\tmax-width: 500px;\n\tz-index: 40;\n\tdisplay: block;\n\twidth: 100%;\n\tborder: 1px solid var(--vscode-editorWidget-border) !important;\n\tborder-color: none;\n\tbackground-color: var(--vscode-editorWidget-background);\n\tcolor: var(--vscode-editorWidget-foreground);\n\tbox-shadow: var(--vscode-widget-shadow) 0 2px 8px;\n}\n\n.codeActionWidget .monaco-list {\n\tuser-select: none;\n\t-webkit-user-select: none;\n\tborder: none !important;\n\tborder-width: 0 !important;\n}\n\n.codeActionWidget .monaco-list .monaco-scrollable-element .monaco-list-rows {\n\theight: 100% !important;\n}\n\n.codeActionWidget .monaco-list .monaco-scrollable-element {\n\toverflow: visible;\n}\n\n/** Styles for each row in the list element **/\n.codeActionWidget .monaco-list .monaco-list-row {\n\tpadding: 0 10px;\n\twhite-space: nowrap;\n\tcursor: pointer;\n\ttouch-action: none;\n\twidth: 100%;\n}\n\n.codeActionWidget .monaco-list .monaco-list-row.code-action.focused:not(.option-disabled)  {\n\tbackground-color: var(--vscode-quickInputList-focusBackground);\n\tcolor: var(--vscode-quickInputList-focusForeground);\n\toutline: 1px solid var(--vscode-menu-selectionBorder, transparent);\n\toutline-offset: -1px;\n}\n\n.codeActionWidget .monaco-list-row.group-header {\n\tcolor: var(--vscode-pickerGroup-foreground);\n\tfont-weight: bold;\n}\n\n.codeActionWidget .monaco-list .group-header,\n.codeActionWidget .monaco-list .option-disabled,\n.codeActionWidget .monaco-list .option-disabled:before,\n.codeActionWidget .monaco-list .option-disabled .focused,\n.codeActionWidget .monaco-list .option-disabled .focused:before {\n\tcursor: default !important;\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tbackground-color: transparent !important;\n\toutline: 0 solid !important;\n}\n\n.codeActionWidget .monaco-list-row.code-action {\n\tdisplay: flex;\n\tgap: 10px;\n\talign-items: center;\n}\n\n.codeActionWidget .monaco-list-row.code-action.option-disabled {\n\tcolor: var(--vscode-disabledForeground);\n}\n\n.codeActionWidget .monaco-list-row.code-action.option-disabled .codicon {\n\topacity: 0.4;\n}\n\n.codeActionWidget .monaco-list-row.code-action:not(.option-disabled) .codicon {\n\tcolor: inherit;\n}\n\n.codeActionWidget .monaco-list-row.code-action .title {\n\tflex: 1;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n/* Action bar */\n\n.codeActionWidget .codeActionWidget-action-bar {\n\tmargin-top: 4px;\n\tmargin-bottom: 4px;\n}\n\n.codeActionWidget .codeActionWidget-action-bar::before {\n\tdisplay: block;\n\tcontent: \"\";\n\twidth: 100%;\n\tmargin-bottom: 4px;\n\tborder-bottom: 1px solid var(--vscode-menu-separatorBackground);\n}\n\n.codeActionWidget .codeActionWidget-action-bar .actions-container {\n\tpadding: 0 10px;\n}\n\n.codeActionWidget-action-bar .action-label {\n\tcolor: var(--vscode-textLink-activeForeground);\n\tpointer-events: all;\n}\n\n.codeActionWidget-action-bar .action-item {\n\tmargin-right: 10px;\n\tpointer-events: none;\n}\n\n.codeActionWidget-action-bar .action-label:hover {\n\tbackground-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
